import axios from 'axios';
import { KEY_LOCALSTORAGE } from 'src/app/modules/auth/core/_consts';
import { OctResponse } from 'src/app/modules/models/OctResponse';
import { APP_CONFIGURATION_KEYS } from 'src/app/modules/utils/Constant';
import { localStorageItem } from 'src/app/modules/utils/LocalStorage';
import { ServiceTemplateRequest } from './types';

const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
	APP_CONFIGURATION_KEYS.API_URL
];

export const saveServiceTemplate = async (
	params: ServiceTemplateRequest
): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(`${BASE_URL}/order-set/save`, params);
	return data;
};

export const getServiceTemplate = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/order-set/get-by-id/${id}`);
	return data;
};

export const deleteServiceTemplate = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.delete<OctResponse<any>>(
		`${BASE_URL}/order-set/delete-by-id/${id}`
	);
	return data;
};

export const getServiceTemplates = async (params: any): Promise<any> => {
	const { data } = await axios.post<any>(`${BASE_URL}/order-set/search`, params);
	return data;
};
